import "./Title.css";

import { CssBaseline } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import Title from "./Title";
import Card from "../Card/Card";
import InputConainer from "../Input/InputConainer";

import { Droppable } from "react-beautiful-dnd";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#EBECF0",
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(1),
    paddingTop: theme.spacing(1),
  },
  cardContainer: {
    marginTop: theme.spacing(2),
    overflowY: "auto",
    flex: 1,
  },
  contCard: {
    borderColor: "#fff",
    borderWidth: 1,
    padding: 10,
    borderStyle: "dashed",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    borderRadius: 5,
    marginHorizontal: 8,
    marginTop: 15,
    paddingTop: 0,
    minWidth: 300
  },
  contCardFirst: {
    borderColor: "#21212c",
    backgroundColor: "#21212c",
    borderWidth: 3,
    padding: 10,
    paddingTop: "1px",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    borderRadius: 5,
    marginTop: 15,
    marginHorizontal: 8,
  },
  resizable: {
    marginRight: "20px",
    width: "300px",
    borderRadius: "7px",
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(1),
    paddingTop: theme.spacing(1),
    boxShadow:
      "0px 2px 1px -1px rgba(0, 0, 0, 0.2), " +
      "0px 1px 1px 0px rgba(0, 0, 0, 0.14), " +
      "0px 1px 3px 0px rgba(0, 0, 0, 0.12)",
    display: "flex",
    flexDirection: "column",
    alignSelf: "stretch",
  },
  innerContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
}));

const List = ({ list, index, getContainerPosition, checkBooks, forkliftDrivers }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const tipo = urlParams.get("tipo");
  const classes = useStyles();

  console.log('list', list)

  return (
    <div
      className={classes.resizable}
      // defaultSize={{
      //   height: "auto",
      //   width: 300,
      // }}
    >
      <div elevation={0} id={list._id} index={index} className={classes.innerContainer}>
        <CssBaseline />
        <Title title={list.title} index={index} />
        <div
          className={list._id == "0" ? classes.contCardFirst : classes.contCard}
        >
          <Droppable droppableId={list._id}>
            {(provided) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                className={classes.cardContainer}
              >
                {list.cards &&
                  list.cards.map((card, i) => (
                    <Card
                      checkBooks={checkBooks}
                      forkliftDrivers={forkliftDrivers}
                      getContainerPosition={getContainerPosition}
                      key={card.id}
                      card={card}
                      cardIndex={i}
                      listIndex={index}
                      type="listado"
                    />
                  ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </div>

        <InputConainer listID={list._id} index={index} type={"card"} />
      </div>
    </div>
  );
};

export default List;
